import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {
  email: string = "";
  errors: string[] = [];
  errorResponse: string = '';
  isEmailSent: boolean = false;

  constructor(public auth: AuthService, private router: Router) {}

  ngOnInit() {
  }

  canSend() {
    return this.email !== '';
  }

  validEmail(): boolean {
    if (this.email === '') return false;

    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(this.email);
  }

  send() {
    this.errors = [];
    this.errorResponse = "";
    if (this.validEmail() === false) this.errors.push('invalid-email');

    if (this.errors.length > 0) return false;

    this.auth.canPasswordReset(this.email)
    .then((response: any) => {
      if (response.length > 0 && response[0] === 'password') {
        this.auth.passwordResetEmail(this.email)
        this.isEmailSent = true;
      } else {
        this.errorResponse = "まだ登録していないまたはメールで登録したユーザーではありません。"
      }
    })
  }

  hasError(value: string): boolean {
    return this.errors.indexOf(value) >= 0;
  }
}
